import { getIsEarlyBirdActive } from "@Modules/eventPage/utils/earlyBird";
import React, { FC } from "react";
import { IUpsellListings } from "../IUpsellListings";

const ItemPrice: FC<IUpsellListings.IItemPrice> = ({
    item,
    eventCurrencySymbol,
    areIntlPaymentsEnabled,
}) => {
    const currencyTag: JSX.Element = (
        <span className="montserrat">{eventCurrencySymbol}</span>
    );

    return getIsEarlyBirdActive({
        eventData: item,
        areIntlPaymentsEnabled,
        isUpsellListing: true,
    }) ? (
        <>
            {currencyTag}
            {item.updated_price}
            {/* 
                16/may/2023 - dev | @ishtiaq
                Product call to remove the strikeout price, and only display the updated price
                1. updated will have the price_per_head value in case of no discount's
                2. updated will have the discount value in case of early bird / discount.
                3. updated will have the upsell price value in case of order bump.
                note: backend is responsible for handling the discount price here
            */}
            {/* &nbsp;
            <del>
                {currencyTag}
                {item?.price_per_head}
            </del> */}
        </>
    ) : (
        <>
            {currencyTag}
            {item.updated_price}
        </>
    );
};

export default ItemPrice;
